// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".app-drawer[data-v-45c1f172] {\n  overflow: hidden !important;\n}\n.app-drawer__inner[data-v-45c1f172] {\n  height: calc(100vh - 112px);\n}\n.app-drawer .drawer-menu--scroll[data-v-45c1f172] {\n  height: calc(100vh - 48px);\n  overflow: auto;\n}", ""]);
// Exports
module.exports = exports;
